import {Artwork} from '../types/artwork';

export const museumArtworks: Artwork[] = [
    {
        id: '0',
        title: '',
        description: 'Mira un resumen de lo que hemos sido en estos años',
        imageUrl: '/Story/History-Intro.png',
        year: '2018 - 2025 y contando...',
        location: '',
        locationUrl: ''
    },
    {
        id: '1',
        title: 'Nos conocimos...',
        description: 'Nos conocimos en un comedor de la Ibero por casualidad y travesura de un amigo en común. En realidad ninguno de los dos estaba con ganas de conocer a alguien nuevo.\n\nCasi de inmediato nos volvimos muy cercanos y la línea que separaba el romance de la amistad cada día se borraba más. Nos volvimos novios el 13 de enero del 2018.',
        imageUrl: '/Story/History-Ibero.png',
        year: '23/10/2017 - Lun, 3:40 PM',
        location: 'Ibero, CDMX',
        locationUrl: 'https://www.google.com/maps/place/Universidad+Iberoamericana+Ciudad+de+M%C3%A9xico/@19.3691932,-99.2649953,17.5z/data=!4m12!1m5!3m4!2zMTnCsDIyJzE2LjUiTiA5OcKwMTUnNDQuOCJX!8m2!3d19.3712382!4d-99.2624477!3m5!1s0x85d200db00f55383:0x31d84ccbb5acaf18!8m2!3d19.3694072!4d-99.2640157!16zL20vMDNiYzNj?entry=ttu&g_ep=EgoyMDI1MDkzMC4wIKXMDSoASAFQAw%3D%3D'
    },
    {
        id: '2',
        title: 'Amor a la Distancia',
        description: 'Gran parte de nuestra relación la vivimos a distancia; Lalo desde Cuba, luego Eli en Chicago y después fueron 2 años de pandemia donde no pudimos estar tan cerca uno del otro.',
        imageUrl: '/Story/History-Distancia.png',
        year: '18/07/2020 - Sab, 3:20 PM',
        location: 'Los Parajes, Veracruz (Huayacocotla)',
        locationUrl: "https://maps.app.goo.gl/wtU1i9D9ARNmbLi79"
    },
    {
        id: '3',
        title: 'Juntos por el mundo',
        description: 'Hemos tenido el privilegio de viajar juntos por muchas partes de México: Puebla, Guerrero, Guanajuato, Chiapas, Edomex, Quintana Roo, Veracruz, Hidalgo, Morelos.\nY también por otras partes del mundo: Chicago, Nueva York y Ontario.',
        imageUrl: '/Story/History-Viajes.png',
        year: '5/11/2022 - Sab, 3:34 PM',
        location: 'Valle de Bravo, Estado de México',
        locationUrl: 'https://maps.app.goo.gl/oUwCvsxCh4VL1ek56'
    },
    {
        id: '4',
        title: 'Nuestro primer viaje: Chicago',
        description: 'Nos tocó la primera nevada del año en pleno Halloween. ¡Lalo conoció la nieve por primera vez!',
        imageUrl: '/Story/History-Chicago.png',
        year: '31/10/2019 - Jue, 2:02 PM',
        location: 'DuSable Bridge, Chicago, IL, Estados Unidos',
        locationUrl: 'https://maps.app.goo.gl/bqHVXm78wMpVQNqs7'
    },
    {
        id: '5',
        title: 'Nuestro viaje más lejano: Ontario',
        description: 'Manejamos kilómetros y kilómetros conociendo muchos lugares bonitos de la provincia; desde Algonquin Park, Muskoka, Waterloo, Toronto y hasta las cataratas del Niagara.',
        imageUrl: '/Story/History-Canada.png',
        year: '21/06/2022 - Mar, 3:54 PM',
        location: 'Niagara Falls, ON, Canada',
        locationUrl: 'https://maps.app.goo.gl/AF9aeqXXA3Jj4fBU8'
    },
    {
        id: '6',
        title: 'Viviendo Juntos',
        description: 'En 2023 comenzamos a vivir la experiencia de vivir juntos. Hemos aprendido mucho uno del otro y hemos crecido como personas.\nCohabitamos con Hootsey, una schnauzer que vive al límite y dos hermanos gatitos adoptados.',
        imageUrl: '/Story/History-Home.png',
        year: '2/04/2023 - Dom, 10:52 AM',
        location: 'Cuajimalpa, CDMX',
        locationUrl: 'https://maps.app.goo.gl/uajSbVdBnn1kaQnm6'
    },
    {
        id: '7',
        title: 'She said yes!',
        description: 'Eli ni se lo imaginaba, pero el 15 de Noviembre del 2024 mientras estábamos de vacaciones en la playa, Lalo se arrodilló y le pidió matrimonio.\nDespués del shock de emoción, un pez Globo, y muchas lágrimas de felicidad, supimos todos los detalles del plan secreto; desde asegurarse que llevara manicura fresca, encubrir a una amiga para saber la talla del anillo, contratar un fotógrafo secretamente, hasta ir a la casa de los suegros a dar la noticia… Todo sin que Eli sospechara nada.',
        imageUrl: '/Story/History-SheSaid.png',
        year: '15/11/2024 - Vie, 5:56 PM',
        location: 'Puerto Aventuras, Quintana Roo',
        locationUrl: 'https://maps.app.goo.gl/JvLetJj4Sj4JB5BK7'
    },
    {
        id: '8',
        title: 'Encaminados al futuro',
        description: 'Han sido casi 8 años de este viaje lleno de aprendizajes y experiencias bellas. Estamos emocionados por iniciar esta nueva etapa juntos.',
        imageUrl: '/Story/History-Future.png',
        year: '11/06/2025 - Mie, 12:11 PM',
        location: 'Presa Iturbide, Estado de México',
        locationUrl: 'https://maps.app.goo.gl/vgDZqULctzqPJ9qG9'
    }
];